const rollingRefreshIntervalLabels = Object.freeze({
  0: 'Audience_Segment_Form_Rolling_RefreshInterval_1h',
  1: 'Audience_Segment_Form_Rolling_RefreshInterval_15m',
  2: 'Audience_Segment_Form_Rolling_RefreshInterval_12h',
  3: 'Audience_Segment_Form_Rolling_RefreshInterval_24h'
})

const rollingRefreshIntervalEnum = Object.freeze({
  HOUR: 0,
  QUARTER_HOUR: 1,
  HALF_DAY: 2,
  DAY: 3
})

export { rollingRefreshIntervalLabels, rollingRefreshIntervalEnum }



// WEBPACK FOOTER //
// ./src/modules/audiences/enum/RollingRefreshIntervalEnums.js